import { PowerSupplyPictogram } from './PowerSupplyPictogram';

export type PowerSupplyPictogramIncludedProps = {
  width?: string;
};

export const PowerSupplyPictogramIncluded = ({ width }: PowerSupplyPictogramIncludedProps) => (
  <PowerSupplyPictogram width={width} type="Included" />
);
